<template>
  <div class="filter-grid  critical-component-clear">
    <div class="grid">
      <div
        v-if="template != 'sawmills'"
        class="filter-value__wrapper"
        :class="filterClass"
      >
        <overlay
          v-if="isMobile"
          key="filters"
          block-class="filter-drawer"
          direction="up"
          namespace="filters"
          type="drawer"
        >
          <template #body>
            <div class="form-group" >
              <p
                class="text-body-l-regular"
                v-text="$string('collection.sort.label')"
              />
              <div
                v-for="(option, index) of sortOptions"
                :key="`sort-modal-${index}`"
              >
                <radio-input
                  :id="`sortModal${index}`"
                  name="sort"
                  :label="sortLabel(option)"
                  :model-value="sort"
                  :value="option"
                  :checked="sort == option"
                  @change="updateSort(option)"
                />
              </div>
            </div>

            <filter-value
              :filters="filters"
              :secondary-collection="secondaryCollection"
              @update-filters="updateFilters"
            />
            <div
              v-if="applyFilterCta"
              class="filter-apply"
            >
              <btn
                :label="$string('collection.filter.apply_filters')"
                :show-icon="false"
                @click="closeOverlay('filters')"
              />
            </div>
          </template>
        </overlay>
        <filter-value
          v-else-if="secondaryCollection"
          :filters="filters"
          :secondary-collection="secondaryCollection"
          @update-filters="updateFilters"
        />

        <filter-value
          v-else-if="!loading"
          :filters="filters"
          :secondary-collection="secondaryCollection"
          @update-filters="updateFilters"
        />
      </div>
      <div
        class="filter-grid__product-grid"
        :class="gridSize"
      >
        <div class="filter-grid__products-header col xs-span my-m my-l-desktop">
          <div
            v-if="isMobile && template !== 'sawmills'"
            class="filter-grid__filter--mobile"
          >
            <btn
              :label="$string('collection.filter.filter_and_sort')"
              modifiers="text reversed"
              show-icon
              @click="openFilters"
            >
              <template #icon>
                <icon-filter />
              </template>
            </btn>
            <span
              class="filter-grid__filter-count text-heading-3xs"
              v-text="getFilterCount"
            />
          </div>
          <div
            class="filter-grid__count"
          >
            <p
              v-if="currentResultCount && totalResultsCount"
              class="text-body-l-regular"
              v-text="productCount"
            />
          </div>
          <div
            v-if="template != 'sawmills'"
            class="
              filter-grid__product-sort
              mb-2xl0-desktop
              text-body-s-regular
              text-body-m-regular-desktop
              col xs6 l9
            "
          >
            <div class="form-group" v-if="isMobile">
              <label
                class="text-body-l-regular"
                :for="$string('collection.sort.title')"
                v-text="$string('collection.sort.label')"
              />
              <select
                :id="$string('collection.sort.title')"
                v-model="sort"
                class="border py-2 px-3 text-body-l-regular"
                @change="updateSort"
              >
                <option
                  v-for="(option, index) of sortOptions"
                  :key="`sort-${index}`"
                  :value="option"
                  v-text="sortLabel(option)"
                />
              </select>
            </div>
          </div>
        </div>
        <div class="filter-grid__products grid col xs-span">
          <temaplte v-if ="productList.length  == 0" class="col l12">
            <p class="text-body-m-bold text-body-l-bold-desktop">No product found</p>
          </temaplte>
          <template
            v-else
            v-for="(product, index) of productList"
            :key="index"
          >
            <div
              v-if="banner && index === bannerPosition"
              :class="gridClass"
            >
              <div
                class="main-collection-banner"
                :class="{ 'main-collection-banner--sawmills': template === 'sawmills' }"
                v-html="banner"
              />
            </div>

            <div :class="gridClass" >
              <product-card-sawmill
                v-if="template == 'sawmills'"
                :product="product"
                :labels="labels"
                @click="captureClickedProduct(product)"
                @product-card-loaded="captureLoadedProduct"
              />

              <product-card
                v-else-if="loading && product"
                :product="product"
                :labels="labels"
                :plp=true
                :loading="loading"
                @display-options="getProductVariants(product)"
                @click="captureClickedProduct(product)"
                @product-card-loaded="captureLoadedProduct"
              />

              <product-card
                v-else
                :product="product"
                :labels="labels"
                :plp=true
                :loading="loading"
                @display-options="getProductVariants(product)"
                @click="captureClickedProduct(product)"
                @product-card-loaded="captureLoadedProduct"
              />
             
            </div>
          </template>
          <div v-if="comingsoon" :class="gridClass" >
                <div class="filter-grid__comingsoon">
                  <img v-if="cbanner" :src="cbanner.src" alt="">
                  <img v-else src="https://frontiersawmills-dev.myshopify.com/cdn/shop/files/placeholder-image.png" ratio="3:2"/> 
                </div>
                <div class="filter-grid__comingsoon_title pl-5xl pr-5xl"> 
                  <p class="text-heading-xl text-heading-2xl-desktop">{{ctext}}</p></div>
              </div>

          <div v-if="searchMore" class="filter-grid__load-more grid col xs-span py-3xl">
            <btn
              class="filter-grid__load-btn"
              :label="loadMoreCtaText"
              :show-icon="false"
              modifiers="secondary"
              @click="$emit('load-more-products')"
            />
          </div>
        </div>
      </div>
    </div>

    <product-details-drawer
      v-if="productDrawer"
      :product="productDrawer"
      :selected-variant="selectedVariant"
    />
  </div>
</template>

<script>

import Btn from '~global/btn/btn'
import Overlay from '~global/overlay/overlay'
import ProductCard from '~async/product-card/product-card'
import ProductCardSawmill from '~async/product-card-sawmill/product-card-sawmill'
import ProductDetailsDrawer from '~async/product-details-drawer/product-details-drawer'
import IconFilter from '~icons/general/filter.svg'
import FilterValue from '~async/filter-value/filter-value'
import RadioInput from '~async/utils/radio-input/radio-input'
import { mapActions, mapGetters, mapState } from 'vuex'
import { formatProduct, formatUrl } from '~/helpers/format'
import productQuery from '~graphql/product.gql'
import ResponsiveImage from '~global/images/responsive-image'

import {
  KlevuSearchSorting,
// eslint-disable-next-line import/no-unresolved
} from '@klevu/core'

/**
 * Vue: Collection grid (filter-grid )
 * -----------------------------------------------------------------------------
 * Grid containing collection and search product cards.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'FilterGrid',
  components: {
    Btn,
    ResponsiveImage,
    FilterValue,
    IconFilter,
    Overlay,
    ProductCard,
    ProductCardSawmill,
    ProductDetailsDrawer,
    RadioInput,
  },

  props: {
    productList: {
      type: Array,
      default: () => [],
    },
 
    currentResultCount: {
      type: [Boolean, Number],
      default: false,
    },
    comingsoon:{
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    banner: {
      type: [Boolean, String],
      default: false,
    },
    bannerPosition: {
      type: [Number, String],
      default: null,
    },
    productClickEvent: {
      type: [Boolean, Function],
      default: false,
    },
    cbanner:{
      type: Object,
      default: null,
    },
    ctext:{
      type: String,
      default: null,
    },
    searchMore: {
      type: Boolean,
      default: false,
    },
    totalResultsCount: {
      type: [Boolean, Number],
      default: false,
    },
    template: {
      type: String,
      default: '',
    },
    gridSize: {
      type: String,
      default: 'col xs-span l8',
    },
    gridClass: {
      type: String,
      default: 'col xs-span s6 l6',
    },
    labels: {
      type: Object,
      default: () => ({
        new: '',
        sale: '',
        featured: '',
        best_seller: '',
        freeShipping: '',
      }),
    },
    selectedtags: {
      type: Array,
      default: () => [],
    },
    liquid: {
      type: Object,
      default: () => ({}),
    },
    secondaryCollection: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: [Boolean],
      default: false,
    },
  },

  emits: {
    'update-filters': () => true,
    'update-search-sort': () => true,
    'load-more-products': () => true,
    'all-cards-loaded': () => true,
  },

  data() {
    return {
      productDrawer: false,
      drawerModel: false,
      selectedVariant: false,
      sort: KlevuSearchSorting.Relevance,
      sortOptions: KlevuSearchSorting || [],
      viewedProducts: [],
      productCardloadCount: 0,
      allCardsLoaded: false,
      applyFilterCta: false,
      totalFilterCount: 0,
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    productCount() {
      const text = this.$string('collection.count')

      if (!text) {
        return ''
      }

      return text.replace('{{current}}', this.currentResultCount).replace('{{total}}', this.totalResultsCount)
    },

    bannerClass() {
      if (this.template === 'sawmills') {
        return 'xs-span l12'
      }

      return 'xs-span l8'
    },

    loadMoreCtaText() {
      return this.$string('collection.load_more').replace('{{count}}', this.totalResultsCount - this.currentResultCount)
    },

    filterClass() {
      const firstLevelClass = 'collection-filter__first-level col xs6 l4'
      const secondLevelClass = 'collection-filter__second-level col xs-span l12'
      return this.secondaryCollection ? secondLevelClass : firstLevelClass
    },

    getFilterCount() {
      if (!this.selectedtags) {
        return 0
      }

      const filters =this.selectedtags
      return [].concat(...filters).length
    },
  },

  watch: {

    getActiveOverlay() {
      if (!this.getActiveOverlay) {
        this.productDrawer = false
      }
    },

    productDrawer() {
      if (!this.productDrawer) {
        return
      }

      this.selectedVariant = this.productDrawer.variants[0]
    },
  },

  mounted() {
    this.setSortOptions()
    if(this.filters.length == 0) {
      this.filters= this.liquid.filters
    }
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
      closeOverlay: 'overlays/close',
    }),

    captureLoadedProduct() {
      if (this.allCardsLoaded) {
        return
      }

      this.productCardloadCount += 1
      if (this.productCardloadCount >= 6 || this.productCardloadCount >= this.totalResultsCount) {
        this.allCardsLoaded = true
        this.$emit('all-cards-loaded')
      }
    },

    captureClickedProduct(product) {
      if (this.productClickEvent) {
        this.productClickEvent(product.id, product.title)

      }
    },
    updateSort(sort) {
      if (sort && !sort?.target) {
        this.sort = sort
      }

      this.$emit('update-search-sort', this.sort)
    },

    updateFilters(key, value) {
      this.applyFilterCta = true
      this.$emit('update-filters', key, value)
    },

    openFilters() {
      this.applyFilterCta = false

      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'filters',
      })
    },

    openProductDetails() {
      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'details',
      })
    },

    setSortOptions() {
      const selectedOptions = ['RELEVANCE', 'NAME_ASC', 'NAME_DESC', 'PRICE_ASC', 'PRICE_DESC']
      this.sortOptions = selectedOptions
    },

    sortLabel(option) {
      const label = `collection.sort.${option.toLowerCase()}`
      return this.$string(`${label}`)
    },

    async getProductVariants(product) {
      const { country, language } = window.cnvs.store
      const savedVariant = this.liquid.products.find((item) => item.handle === product.handle)
      if (savedVariant) {
        this.productDrawer = savedVariant
        this.drawerModel = product.compatibility
        return
      }

      try {
        const response = await cnvs.Query({
          query: productQuery,
          variables: {
            country,
            handle: product.handle,
            language,
          },
        })

        const formattedProduct = formatProduct(response)
        this.productDrawer = formattedProduct
        this.viewedProducts.push(formattedProduct)
        this.drawerModel = product.compatibility
      } catch (error) {
        this.productDrawer = false
        window.location = formatUrl(product.url)
        cnvs.ReportError('Failed to fetch products', error)
      }
    },
  },
}
</script>

<style lang="scss">
@import './filter-grid';
</style>
